export const EURO_CURRENCY_MAP = {
  ...Object.fromEntries(
    [
      'AT',
      'BE',
      'HR',
      'CY',
      'EE',
      'FI',
      'FR',
      'DE',
      'GR',
      'IE',
      'IT',
      'LV',
      'LT',
      'LU',
      'MT',
      'NL',
      'PT',
      'SK',
      'SI',
      'ES',
    ].map((code) => [code, 'eur'] as [string, string]),
  ),
};

export const GEO_CURRENCY_MAP: Record<string, string> = {
  ...EURO_CURRENCY_MAP,
  CA: 'cad',
  AU: 'aud',
  BR: 'brl',
  IN: 'inr',
  MX: 'mxn',
  AR: 'ars',
  PA: 'usd-pa',
  SV: 'usd-sv',
  CO: 'cop',
  GT: 'gtq',
  PL: 'pln',
  DO: 'dop',
  ZA: 'zar',
  PE: 'pen',
  SA: 'sar',
  MY: 'myr',
  PT: 'eur-pt',
  HU: 'huf',
  BO: 'bob',
  RO: 'ron',
};

export const CRM_GEO_CURRENCIES = new Set(['cad', 'aud', 'cop', 'usd-pa']);

/** Non-eurozone countries that see the existing EUR plans on geoprice_ntp_eu. */
export const NTP_EU_DISPLAY_COUNTRIES = new Set(['BG', 'CZ', 'DK', 'HU', 'PL', 'RO', 'SE']);

export const GEO_UPSELL_PRESETS = {
  tp: ['cad', 'aud', 'cop', 'zar'] as const,
  tp_ar: ['cad', 'aud', 'ars'] as const,
} as const;

export type GeoUpsellPreset = keyof typeof GEO_UPSELL_PRESETS;

export type GeoUpsellMarket =
  (typeof GEO_UPSELL_PRESETS.tp)[number] | (typeof GEO_UPSELL_PRESETS.tp_ar)[number];

export function resolveGeoUpsellMarket(
  userLocation: string | null | undefined,
  preset: GeoUpsellPreset | undefined,
): GeoUpsellMarket | null {
  if (!preset) return null;
  const allowed = GEO_UPSELL_PRESETS[preset] as readonly string[];
  const tier = (userLocation && GEO_CURRENCY_MAP[userLocation]?.toLowerCase()) || '';
  return (allowed as readonly string[]).includes(tier) ? (tier as GeoUpsellMarket) : null;
}
